"use strict";

var _taggedTemplateLiteral = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledcomponents = require('styled-components');

var u = _styledcomponents.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n"])), function (_ref) {
  var e = _ref.$gridLocation;
  return e && _styledcomponents.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            grid-area: ", ";\n        "])), e);
}),
    c = ["xxxl", "xxl", "xl", "lg", "md", "sm", "xs", "xxs", "xxxs"],
    d = /([+-])/,
    S = function S(e, n, r) {
  var o = n[0].trim();
  if (!c.includes(o)) return r;
  var p = e[o + "Value"];

  for (var s = 2; s < n.length; s += 2) {
    var g = n[s].trim();
    if (!c.includes(g)) return r;
    s % 2 === 0 && (n[s - 1] === "+" ? p += e[g + "Value"] : p -= e[g + "Value"]);
  }

  return "".concat(p, "px");
},
    t = exports.b = function (e, n) {
  if (c.includes(n)) return e[n];
  var r = n.split(d);
  return r.length > 1 ? S(e, r, n) : n;
},
    T = exports.c = _styledcomponents.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n"])), function (_ref2) {
  var e = _ref2.$padding,
      n = _ref2.theme;
  return e && e.length > 0 && _styledcomponents.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            padding: ", ";\n        "])), t(n.spacing, e));
}, function (_ref3) {
  var e = _ref3.$paddingBottom,
      n = _ref3.theme;
  return e && e.length > 0 && _styledcomponents.css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n            padding-bottom: ", ";\n        "])), t(n.spacing, e));
}, function (_ref4) {
  var e = _ref4.$paddingLeft,
      n = _ref4.theme;
  return e && e.length > 0 && _styledcomponents.css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n            padding-left: ", ";\n        "])), t(n.spacing, e));
}, function (_ref5) {
  var e = _ref5.$paddingRight,
      n = _ref5.theme;
  return e && e.length > 0 && _styledcomponents.css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n            padding-right: ", ";\n        "])), t(n.spacing, e));
}, function (_ref6) {
  var e = _ref6.$paddingTop,
      n = _ref6.theme;
  return e && e.length > 0 && _styledcomponents.css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n            padding-top: ", ";\n        "])), t(n.spacing, e));
}),
    y = exports.d = _styledcomponents.css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n"])), function (_ref7) {
  var e = _ref7.$margin,
      n = _ref7.theme;
  return e && e.length > 0 && _styledcomponents.css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n            margin: ", ";\n        "])), t(n.spacing, e));
}, function (_ref8) {
  var e = _ref8.$marginBottom,
      n = _ref8.theme;
  return e && e.length > 0 && _styledcomponents.css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n            margin-bottom: ", ";\n        "])), t(n.spacing, e));
}, function (_ref9) {
  var e = _ref9.$marginLeft,
      n = _ref9.theme;
  return e && e.length > 0 && _styledcomponents.css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n            margin-left: ", ";\n        "])), t(n.spacing, e));
}, function (_ref10) {
  var e = _ref10.$marginRight,
      n = _ref10.theme;
  return e && e.length > 0 && _styledcomponents.css(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n            margin-right: ", ";\n        "])), t(n.spacing, e));
}, function (_ref11) {
  var e = _ref11.$marginTop,
      n = _ref11.theme;
  return e && e.length > 0 && _styledcomponents.css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n            margin-top: ", ";\n        "])), t(n.spacing, e));
}),
    b = exports.e = _styledcomponents.css(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    ", ";\n"])), u, T, y);

var V = function V(_ref12) {
  var e = _ref12.active,
      _ref12$activePrefix = _ref12.activePrefix,
      n = _ref12$activePrefix === void 0 ? ":active" : _ref12$activePrefix,
      r = _ref12.base,
      o = _ref12.disabled,
      p = _ref12.disabledPrefix,
      s = _ref12.focus,
      _ref12$focusPrefix = _ref12.focusPrefix,
      g = _ref12$focusPrefix === void 0 ? ":focus" : _ref12$focusPrefix,
      l = _ref12.hover,
      _ref12$hoverPrefix = _ref12.hoverPrefix,
      m = _ref12$hoverPrefix === void 0 ? ":hover" : _ref12$hoverPrefix,
      $ = _ref12.isDisabled,
      f = _ref12.keyboardFocus,
      _ref12$keyboardFocusP = _ref12.keyboardFocusPrefix,
      x = _ref12$keyboardFocusP === void 0 ? ":focus-visible" : _ref12$keyboardFocusP,
      h = _ref12.removeStyles;
  return h ? "" : _styledcomponents.css(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n        ", "\n    "])), $ && o ? o : _styledcomponents.css(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n                  ", ";\n\n                  ", "\n\n                  ", "\n\n                  ", "\n\n                  ", "\n\n                  ", "\n              "])), r, m && !!l && _styledcomponents.css(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n                      ", " {\n                          ", ";\n                      }\n                  "])), m, l), g && !!s && _styledcomponents.css(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n                      ", " {\n                          ", ";\n                      }\n                  "])), g, s), n && !!e && _styledcomponents.css(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n                      ", " {\n                          ", ";\n                      }\n                  "])), n, e), p && !!o && _styledcomponents.css(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n                      ", " {\n                          ", ";\n                      }\n                  "])), p, o), x && !!f && _styledcomponents.css(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n                      ", " {\n                          ", ";\n                      }\n                  "])), x, f)));
};

exports.a = u;
exports.b = t;
exports.c = T;
exports.d = y;
exports.e = b;
exports.f = V;